<template>
  <div class="component-hero-about">
    <b-container class="component-hero-about__container">
      <img
        class="component-hero-about__pattern"
        src="~/assets/components/page-about/hero-pattern.svg"
        alt=""
      />
      <h4 class="component-hero-about__text">
        The Hub is a recruitment platform for Nordic startups that offers career
        opportunities for global talents.
      </h4>
    </b-container>
  </div>
</template>

<script>
export default {
  name: 'PageAboutHero'
}
</script>

<style lang="scss">
.component-hero-about {
  padding-top: rem(20px);
  padding-bottom: rem(40px);

  &__container {
    background-color: $blue-200;
    padding: rem(50px) !important;
    overflow: hidden;

    @include media-breakpoint-up(xl) {
      max-width: 1360px !important;
    }

    @include media-breakpoint-only(md) {
      padding-bottom: 0 !important;
    }
  }

  &__pattern {
    width: auto;
    max-width: 100%;

    @include media-breakpoint-down(md) {
      margin-left: 25%;
      margin-top: 10%;
    }

    @include media-breakpoint-down(sm) {
      display: none;
    }
  }

  &__text {
    position: absolute;
    top: rem(50px);
    left: rem(50px);
    max-width: 30%;
    font-weight: 400;
    font-size: rem(24px);
    line-height: 1.33;

    @include media-breakpoint-only(lg) {
      font-size: rem(20px);
    }

    @include media-breakpoint-down(md) {
      max-width: 50%;
    }

    @include media-breakpoint-down(sm) {
      position: relative;
      left: auto;
      top: auto;
      max-width: 100%;
    }
  }
}
</style>
